import { BASE_FORM_ROUTE_PATH } from 'config/routes/routeTypes';
import { matchPathWithoutQuery } from '../../query-params';

export const hasFormMode = url =>
    matchPathWithoutQuery(url, {
        path: BASE_FORM_ROUTE_PATH,
        exact: false,
        strict: false,
    }) !== null;
